import { render, staticRenderFns } from "./SwapIcon.vue?vue&type=template&id=74aadb34&scoped=true&"
import script from "./SwapIcon.vue?vue&type=script&lang=js&"
export * from "./SwapIcon.vue?vue&type=script&lang=js&"
import style0 from "./SwapIcon.vue?vue&type=style&index=0&id=74aadb34&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aadb34",
  null
  
)

export default component.exports